import React, { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";

import classes from "./FileListUpload.module.scss";

let filesToUpload = [];
let allAcceptedFiles = [];

const FileListUpload = (props) => {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach(async (file) => {
      allAcceptedFiles.push(file);
      try {
        let base64 = await readFileAsync(file);
        filesToUpload.push({
          file_name: file.name,
          data_url: base64
        });
      } catch (err) {
        console.log(err);
      }
    });
    props.fileChangeHandler(filesToUpload);
  }, filesToUpload);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({ onDrop });

  let files = allAcceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <section className={classes.wrapper}>
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <p className={classes.upload}>Drag & drop files here, or click to select files</p>
      </div>
      {files.length > 0 ? (
        <aside>
          <p>Save to upload files</p>
          <ul className={classes.files}>{files}</ul>
        </aside>
      ) : null}
    </section>
  );
};

function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;
    reader.onabort = reject;

    reader.readAsDataURL(file);
  });
}

export default FileListUpload;
